/**
 * Nsection B10 Service
 * B.10.基準情景 API 服務
 */

import axios from '../api/axios';

const BASE_URL = '/api/nsection-b10';

// 公式參數（複用 PDD B.7.1 結構，去除 sampling）
export interface FormulaParameter {
  symbol: string;
  para_type?: number | null;
  scenarios: string;
  unit: string;
  annual_value: number | null;
}

export interface FormulaEntry {
  id: string;
  equation_note: string;
  equation: { latex: string };
  parameters: FormulaParameter[];
  calculation_result: { value: number | null; unit: string };
}

export interface NsectionB10Detail {
  id: number;
  organization_id: number;
  proposal_id: number;
  baseline_approaches: string[] | null;
  approach_justification: string | null;
  baseline_identification: string | null;
  baseline_calculate: FormulaEntry[] | null;
  downward_adjusted_baseline: string | null;
  bau_scenario_identification: string | null;
  bau_calculate: FormulaEntry[] | null;
  baseline_bau_comparison: string | null;
  nsection_b10_pct: number;
  edit_by: number;
  created_at: string;
  updated_at: string | null;
}

export interface NsectionB10Update {
  baseline_approaches?: string[];
  approach_justification?: string;
  baseline_identification?: string;
  baseline_calculate?: FormulaEntry[];
  downward_adjusted_baseline?: string;
  bau_scenario_identification?: string;
  bau_calculate?: FormulaEntry[];
  baseline_bau_comparison?: string;
}

const nsectionB10Service = {
  getByProposal: async (proposalId: number): Promise<NsectionB10Detail | null> => {
    const response = await axios.get(`${BASE_URL}/by-proposal/${proposalId}`);
    return response.data;
  },
  update: async (proposalId: number, data: NsectionB10Update): Promise<NsectionB10Detail> => {
    const response = await axios.put(`${BASE_URL}/${proposalId}`, data);
    return response.data;
  },
};

export default nsectionB10Service;
